export default "__VITE_ASSET__BO8Pwy7B__"